import { Drawer } from 'antd';
import { useTranslate } from '@tolgee/react';
import { useQuery } from '@tanstack/react-query';
import { queries } from 'services/queries';
import { useModifyOnChat } from './useModifyOnChat';
import { CustomerSourceContent } from './CustomerSourceContent';
import { EmptyPlaceholder } from '../EmptyPlaceholder';
import { useCleanExpandInCalculation } from '../useUpdateSeekSku';
import { useRef } from 'react';
import { ContentWithDetail } from '../AdjustRelateKnowledge/ContentWithDetail';
import { ContentWithNotSupport } from '../AIErrorReplyDrawer/ContentWithNotSupport';
import { FullLoading } from 'components/FullLoading';

export const ModifyOnChatDrawer = () => {
  const { t } = useTranslate();
  const { meta, visible, hide: hideModifyOnChat } = useModifyOnChat();

  const delayRefetchRef = useRef<NodeJS.Timeout | undefined>(undefined);
  const cleanExpandInCalculation = useCleanExpandInCalculation();

  const msgId = meta?.message?.msgId;
  const conversationId = meta?.conversation?.conversationId;
  const {
    data: supplementKnowledgeDetail,
    refetch: refetchSupplementKnowledgeDetail,
    isLoading: isLoadingSupplementKnowledgeDetail,
  } = useQuery({
    enabled: visible && !!meta && !!msgId && !!conversationId,
    ...queries.qaPair.knowledgeDetailByMsgId({
      conversationId: conversationId || '',
      msgId: msgId || '',
    }),
  });

  const handleDelayRefresh = () => {
    if (delayRefetchRef.current) {
      clearTimeout(delayRefetchRef.current);
    }
    delayRefetchRef.current = setTimeout(() => {
      refetchSupplementKnowledgeDetail().then(() => {
        cleanExpandInCalculation();
      });
    }, 5000);
  };

  let content = <EmptyPlaceholder />;
  if (meta) {
    if (isLoadingSupplementKnowledgeDetail) {
      content = <FullLoading />;
    } else if (supplementKnowledgeDetail?.id) {
      if (supplementKnowledgeDetail.source === 'CUSTOMER') {
        content = (
          <CustomerSourceContent
            conversation={meta?.conversation}
            supplementKnowledgeDetail={supplementKnowledgeDetail}
            onDone={hideModifyOnChat}
            onDelayRefresh={handleDelayRefresh}
            onRefresh={refetchSupplementKnowledgeDetail}
          />
        );
      }
      if (supplementKnowledgeDetail.source === 'AI_ERROR_REPLY') {
        if (supplementKnowledgeDetail.reviewStatus === 'AI_LEARNING_UNSUPPORTED') {
          content = (
            <ContentWithNotSupport
              hideChatPanel
              conversation={meta.conversation}
              dataSource={supplementKnowledgeDetail}
              onRefresh={refetchSupplementKnowledgeDetail}
              onDelayRefresh={handleDelayRefresh}
              onClose={hideModifyOnChat}
            />
          );
        } else {
          content = (
            <ContentWithDetail
              message={meta.message}
              conversation={meta.conversation}
              supplementKnowledgeDetail={supplementKnowledgeDetail}
              onDone={hideModifyOnChat}
              onDelayRefresh={handleDelayRefresh}
              onRefresh={refetchSupplementKnowledgeDetail}
            />
          );
        }
      }
    }
  }

  return (
    <Drawer
      title={t('调整相关知识')}
      width={640}
      bodyStyle={{
        padding: 0,
      }}
      visible={visible}
      onClose={hideModifyOnChat}
    >
      {content}
    </Drawer>
  );
};
